import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXSavedSearchEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxSavedSearchEditContainer";
    }
    render(){
        // console.log("edit saved search");

    }
}